import React, { useState } from "react";
import { Box, Card, Grid, IconButton, Typography } from "@mui/material";

import _ from "lodash";
import PageHeader from "../../materio/@core/components/page-header";
import { filterPlaybooks, loadPlaybooks, Playbook, PlaybookStore, renamePlaybook, savePlaybook, togglePlaybookStatus } from "./PlaybookStore";
import TableHeader from "./TableHeader";
import PencilOutline from 'mdi-material-ui/PencilOutline'
import CustomChip from 'src/materio/@core/components/mui/chip'
import NameDialog from "./NameDialog";
/*import EditPlaybookDrawer from "./EditPlaybookDrawer";*/
import PlaybookView from "./PlaybookView";
import {v4 as uuid } from 'uuid'
import RoleSelector from "../roles/RoleSelector";
import RenderIf, { ClaimType, ClaimValue } from "../common/RenderIf";
import DeleteIcon from '@mui/icons-material/Delete';
import useAwaitableComponent from '../../hooks/useAwaitableComponent'
import ConfirmationDialog from '../common/ConfirmationDialog'
import { ApiResponseType } from '../../types'
import ApplicationStore from '../../stores/ApplicationStore'
import { client } from "../../utils/axios-client";
import MenuBookIcon from '@mui/icons-material/MenuBook';
import EditCadenceDrawer from "./template-library/EditCadenceDrawer";
import { loadOption, OptionsStore } from "../common/OptionsLoader";
import { DataGridPro, GridColDef } from "@mui/x-data-grid-pro";

interface CellType {
    row: Playbook
}

const defaultColumns = [
    {
        flex: 2,
        field: 'name',                
        headerName: 'Name',
        renderCell: ({ row }: CellType) => <Typography>{row.name}</Typography>
    } as GridColDef,
    {
        flex: 0.65,
        align: 'center',        
        headerAlign: 'center',
        field: 'executedCount',        
        headerName: 'Activities',
        renderCell: ({ row }: CellType) => <Typography>{row.executedCount}</Typography>
    } as GridColDef,
    {
        flex: 0.65,
        align: 'center',
        headerAlign: 'center',
        field: 'miCount',
        headerName: 'MI\'s',
        renderCell: ({ row }: CellType) => <Typography>{row.miCount}</Typography>
    } as GridColDef,
    {
        flex: 0.65,
        field: 'mqlCount',        
        align: 'center',      
        headerAlign: 'center',
        headerName: 'MQL\'s',
        renderCell: ({ row }: CellType) => <Typography>{row.mqlCount}</Typography>
    } as GridColDef,
    {
        flex: 0.65,
        align: 'center',      
        headerAlign: 'center',
        field: 'dcCount',        
        headerName: 'DC\'s',
        renderCell: ({ row }: CellType) => <Typography>{row.dcCount}</Typography>
    } as GridColDef,
    {
        flex: 0.65,
        align: 'center',      
        headerAlign: 'center',
        field: 'opportunityCount',        
        headerName: 'Opportunities',
        renderCell: ({ row }: CellType) => <Typography>{row.opportunityCount}</Typography>
    } as GridColDef

]

const PlaybookList = <T extends Playbook>() => {
    const filteredPlaybooks = PlaybookStore.useState(s => s.filteredPlaybooks);
    const selectedPlaybook = PlaybookStore.useState(s => s.selectedPlaybook);
    const [pageSize, setPageSize] = React.useState<number>(10)
    const [filter, setFilter] = React.useState('');
    const [renameDialogOpen, setRenameDialogOpen] = useState<boolean>(false)
    const [librariesOpen, setLibrariesOpen] = useState(false);
    const [templatesOpen, setTemplatesOpen] = useState(false);
    const [addPlaybookOpen, setAddPlaybookOpen] = useState(false);
    const [openPlaybook, setOpenPlaybook] = useState(false);
    const [status, execute, resolve, reject, reset] = useAwaitableComponent();
    const showModal = status !== "idle";

    React.useEffect(() => {
        loadTemplateTypes();
        loadPlaybooks(filter);
    }, []);

    React.useEffect(() => {
        PlaybookStore.update((s, o) => {
            s.filteredPlaybooks = filterPlaybooks(o.playbooks, filter);
        })
    }, [filter])

    //React.useEffect(() => {
    //    if (filteredPlaybooks.length > 0) {
    //        PlaybookStore.update((s, o) => {
    //            var pb = o.filteredPlaybooks.find(s => s.id === 'f6bc707c-9406-42e0-bc9e-3ad2b2b2b61f');

    //            if (pb) {
    //                s.selectedPlaybook = pb;
    //            }
    //        })

    //        setOpenPlaybook(true);
    //    }
    //}, [filteredPlaybooks])

    const handleConfirmDelete = async (row: Playbook) => {
        try {
            const value = await execute();
            const response = await client.delete<ApiResponseType>('/api/playbooks', { params: { playbookId: row.id } });

            if (response.data.succeeded) {
                await loadPlaybooks(filter);

                ApplicationStore.update(s => {
                    s.snackbarMessage = "PLaybook successfully deleted";
                    s.snackbarOpen = true;
                });
            } else {
                alert('Error while deleting playbook.');
            }
        } catch (err) {

        } finally {
            reset();
        }
    };

    const loadTemplateTypes = async () => {
        const options = await loadOption('TemplateTypes');

        OptionsStore.update(s => {
            s.templateTypes = options;
        })
    }

    const columns = [
        ...defaultColumns,        
        {            
            flex:1,            
            sortable: false,
            field: 'actions',
            align: 'center',
            headerAlign: 'center',
            headerName: 'Actions',                                    
            renderCell: ({ row }: CellType) => (
                <Box >
                    <RenderIf claimType={ClaimType.Playbooks} claimValue={ClaimValue.Delete}>
                        <IconButton onClick={() => handleConfirmDelete(row)} title="Delete">
                            <DeleteIcon fontSize='small' />
                        </IconButton>
                    </RenderIf>
                    <RenderIf claimType={ClaimType.Playbooks} claimValue={ClaimValue.Edit}>
                        <IconButton onClick={() => handleStartRename(row)} title="Rename">
                            <PencilOutline fontSize='small' />
                        </IconButton>
                    </RenderIf>

                    <RenderIf claimType={ClaimType.Playbooks} claimValue={ClaimValue.Edit}>
                        <IconButton onClick={() => onOpenPlaybook(row)} title="Edit">
                            <MenuBookIcon fontSize='small' />
                        </IconButton>
                    </RenderIf>
                    
                    <RoleSelector claimType={ClaimType.Playbooks} recordId={row.id} />
                    {/*<IconButton onClick={() => handleEditLibraries(row)} title="Libraries">*/}
                    {/*    <LibraryBooksIcon fontSize='small' />*/}
                    {/*</IconButton>*/}
                    {/*<IconButton onClick={() => handleEditCadences(row)} title="Cadences">*/}
                    {/*    <AccountTreeIcon fontSize='small' />*/}
                    {/*</IconButton>*/}
                </Box>
            )
        } as GridColDef
    ]

    const handleStartRename = (row: Playbook) => {
        console.log(row);
        PlaybookStore.update(s => {
            s.selectedPlaybook = row;
        })

        setRenameDialogOpen(true);
    }

    const handleEditLibraries = (row: Playbook) => {
        PlaybookStore.update(s => {
            s.selectedPlaybook = row;
        })

        setLibrariesOpen(true);
    }

    const handleEditCadences = (row: Playbook) => {
        PlaybookStore.update(s => {
            s.selectedPlaybook = row;
        })

        setTemplatesOpen(true);
    }

    const onAddPlaybook = () => {
        setAddPlaybookOpen(true);
    }

    const onSavePlaybook = async (row: Playbook) => {
        const response = await savePlaybook({ ...row, id: uuid() }, filter);

        if (response.succeeded) {
            setAddPlaybookOpen(false);

        }

        return response;
    }

    const onOpenPlaybook = (row: Playbook) => {
        PlaybookStore.update(s => {
            s.selectedPlaybook = row;
        })

        setOpenPlaybook(true)
    }

    const onClosePlaybook = () => {
        PlaybookStore.update(s => {
            s.selectedPlaybook = null;
        })

        setOpenPlaybook(false)
    }

    if (openPlaybook) return <PlaybookView onClose={onClosePlaybook} />

    return (
        <Grid container spacing={6}>
            <Grid item xs={12}>
                <PageHeader
                    title={<Typography variant='h5'>Playbook List</Typography>}
                    subtitle={
                        <Typography variant='body2'>
                            Create and manage playbooks.
                        </Typography>
                    }
                />
            </Grid>
            <Grid item xs={12}>
                <Card>
                    <TableHeader value={filter} onFilter={(value) => setFilter(value)} onAddRecord={onAddPlaybook} buttonLabel="Add Playbook" title="Search Playbooks" />
                    <DataGridPro
                        autoHeight
                        rows={filteredPlaybooks}
                        columns={columns}
                        pageSize={pageSize}
                        disableSelectionOnClick                        
                        rowsPerPageOptions={[10, 25, 50]}
                        onPageSizeChange={newPageSize => setPageSize(newPageSize)}
                    />

                    {selectedPlaybook && <NameDialog open={renameDialogOpen} onClose={() => setRenameDialogOpen(false)} onSubmit={(data: Playbook) => renamePlaybook(data, filter)} title="Rename Playbook" subTitle="Please enter a name for the playbook" fieldLabel="Playbook Name" confirmButtonLabel="Rename" record={selectedPlaybook} />}
                    <NameDialog open={addPlaybookOpen} onClose={() => setAddPlaybookOpen(false)} onSubmit={onSavePlaybook} title="Create Playbook" subTitle="Please enter a name for the playbook" fieldLabel="Playbook Name" confirmButtonLabel="Create Playbook" record={{ name: '' } as Playbook} />
                    {/*{selectedPlaybook && librariesOpen && <EditPlaybookDrawer open={librariesOpen} onClose={() => setLibrariesOpen(false)} />}*/}
                    {selectedPlaybook && templatesOpen && <EditCadenceDrawer open={templatesOpen} onClose={() => setTemplatesOpen(false)} />}
                </Card>
            </Grid>
            <ConfirmationDialog open={showModal} onConfirm={resolve} onCancel={reject} title="Delete?" message="Are you sure you want to delete the playbook?" confirmButtonText="Delete" cancelButtonText="Cancel" />
        </Grid>
    )
}

export { PlaybookList };
export default PlaybookList;